module.exports = __webpack_public_path__ + "img/stepQuestions.ca982273.png";